
class BackToTop {
  constructor(){
    this.toggles = Array.prototype.slice.call(document.querySelectorAll('.js-totop-toggle'));
    if(this.toggles.length > 0){
      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', e => {
          window.scrollTo({top: 0, behavior: 'smooth'});
        });
      });
    }
  }
} export default BackToTop;
